import('./bootstrap').catch(err => console.error(err));
import { LicenseManager } from  'ag-grid-enterprise' 
 
LicenseManager.setLicenseKey("CompanyName=Amrut Software Private Limited_on_behalf_of_ANALYTICS QUOTIENT - INDIA,LicensedApplication=Olympus,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-027212,ExpiryDate=1_April_2023_[v2]_MTY4MDMwMzYwMDAwMA==390582b04422a48347c898f322c3cbd4");

